import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';

import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { DataTable } from 'primereact/datatable';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Divider } from 'primereact/divider';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { Sidebar } from 'primereact/sidebar';
import { Tag } from 'primereact/tag';
import { Message } from 'primereact/message';
import { Image } from 'primereact/image';
import { TriStateCheckbox } from 'primereact/tristatecheckbox';
import { FileUpload } from 'primereact/fileupload';
import { ProgressSpinner } from 'primereact/progressspinner';
import 'primeicons/primeicons.css';

import moment from 'moment-timezone';

import MessageBox from 'components/MessageBox';
import TableTopTitle from 'components/TableTopTitle';

import fetchApi from 'lib/fetchApi';
import fetchUpload from 'lib/fetchUpload';
import functions from 'lib/functions';

const domain = (process.env.NODE_ENV === 'development') ?
  'http://localhost:54321/functions/v1/cmsapi/' :
  'https://rlrsahkegsezipmbvvcs.supabase.co/functions/v1/cmsapi/'

const PRODUCTS = require('jsons/products.json');

const Purchase = (props) => {
  const toast = useRef(null);
  const uploadRef = useRef(null);
  const [purchases, setPurchases] = useState(null);
  const [selectedPurchase, setSelectedPurchase] = useState(null);
  const [isOpenDetail, setIsOpenDetail] = useState(false);
  const [isLoadingDetail, setIsLoadingDetail] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [purchaseDetail, setPurchaseDetail] = useState(null);
  const [isUnsaved, setIsUnsaved] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [messageBoxData, setMessageBoxData] = useState({
    show: false,
    title: '',
    content: '',
    type: 'warning',
  });
  const [filters, setFilters] = useState({
    user_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    user_group: { value: null, matchMode: FilterMatchMode.CONTAINS },
    product_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    price: { value: null, matchMode: FilterMatchMode.CONTAINS },
    qty: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const [filteredCount, setFilteredCount] = useState(0);

  useEffect(() => {
    props.setPageParams({
      alias: 'purchase',
      title: '點數銷售'
    });
    getPurchases();
  }, []);

  const refreshList = () => {
    setPurchases(null);
    getPurchases();
  };

  const getPurchases = async () => {
    const responseList = await fetchApi('purchase/list');
    if (responseList.data?.purchases) {
      setPurchases(responseList.data.purchases.map((purchase) => {
        return {
          ...purchase,
          user_name: purchase.users.nickname,
          user_group: purchase.users.employer_profiles.length > 0 ? '僱主' : purchase.users.employer_profiles.length > 0 ? '外傭' : '',
          product_name: functions.getObjectValueFromArrayById(PRODUCTS.map((product) => { return {...product, name: product.name.zh}; }), purchase.sales_transactions?.product_id),
          price: `${purchase.sales_transactions.currency} ${purchase.sales_transactions.price_in_purchased_currency}`,
          qty: purchase.qty,
          created_at: purchase.created_at
        };
      }));
      setFilteredCount(responseList.data.purchases.length);
    } else {
      setPurchases([]);
      setFilteredCount(0);
    }
  };

  const showDetail = async (purchase_id) => {
    setPurchaseDetail(null);
    setIsLoadingDetail(true);
    setIsEditing(true);
    setIsOpenDetail(true);
    setIsSaving(false);
    setIsUnsaved(false);
    setTimeout(async () => {
      const response = await fetchApi('purchase/list', {
        id: purchase_id
      });
      if (response.state === 1 && response.data?.purchases?.length > 0) {
        const purchase = response.data.purchases[0];
        setPurchaseDetail({
          ...purchase,
          user_name: purchase.users.employer_profiles.length > 0 ? purchase.users.employer_profiles[0].employer_name : purchase.users.helper_profiles.length > 0 ? purchase.users.helper_profiles[0].helper_name : '',
          user_group: purchase.users.employer_profiles.length > 0 ? '僱主' : purchase.users.employer_profiles.length > 0 ? '外傭' : '',
          product_name: functions.getObjectValueFromArrayById(PRODUCTS.map((product) => { return {...product, name: product.name.zh}; }), purchase.sales_transactions?.product_id),
          qty: purchase.qty,
          created_at: purchase.created_at,
        });
        setIsLoadingDetail(false);
      }
    }, 100);
  };

  const formatListFields = (field, row) => {
    switch (field) {
      case 'is_valid':
        return row.is_valid ? <Tag severity="success" value="生效" /> : <Tag severity="danger" value="過期" />;
      break;
      case 'created_at':
        return moment(row.created_at).format('YYYY年M月D日 H:mm');
      break;
    };
  };

  const filterElementIsValid = (options) => {
    return <TriStateCheckbox value={options.value} onChange={(e) => options.filterApplyCallback(e.value)} />;
  };
  const filterInputText = (options) => {
    return <InputText value={options.value} onChange={(e) => options.filterApplyCallback(e.target.value)} className="p-inputtext-sm p-2" />
  };

  const onHideSidebar = () => {
    if (isSaving) {
      return false;
    }
    if (isUnsaved) {
      confirmDialog({
        message: '你還未儲存變更，確定要關閉？',
        header: '未儲存變更',
        icon: 'pi pi-info-circle',
        defaultFocus: 'reject',
        acceptClassName: 'p-button-warning',
        accept: () => {setIsOpenDetail(false)},
      });
    } else {
      setIsOpenDetail(false);
    }
  };

  const reorderingPurchases = async (e) => {
    const {
      value,
      dragIndex,
      dropIndex
    } = e;
    // update locally
    const purchases = value.map((purchase, index) => {
      return {
        ...purchase,
        ordering: index+1
      };
    });
    setPurchases(purchases);
    // update remotely
    const responseReorder = await fetchApi('purchase/reordering', {
      drag: dragIndex + 1,
      drop: dropIndex + 1
    });
  };

  return (
    <>
      <div className="mb-2">
        <Toolbar
          className="flex-column lg:flex-row p-0 border-0 bg-white align-items-start"
          start={<TableTopTitle title="點數銷售列表" subTitle="這裡顯示所有點數銷售記錄。" />}
          end={
            <>
              <Button icon="pi pi-sync" size="small" className="w-2rem h-2rem p-0 mr-3" rounded onClick={refreshList} disabled={purchases===null} />
              {/* <Button label="新增" size="small" icon="pi pi-plus" onClick={createPurchase} /> */}
            </>
          }
        />
      </div>
      <DataTable
        value={purchases}
        selectionMode="single"
        onRowClick={(e) => {showDetail(e.data.id)}}
        emptyMessage={purchases===null?'讀取中...':'未有記錄'}
        selection={selectedPurchase}
        stripedRows
        onSelectionChange={(e) => setSelectedPurchase(e.value)} dataKey="id"
        metaKeySelection={true}
        removableSort
        paginator
        rows={15}
        rowsPerPageOptions={[15, 30, 50, 100]} 
        filterDisplay="row"
        filters={filters}
        reorderableRows
        onRowReorder={(e) => reorderingPurchases(e)}
        onValueChange={(filteredData) => {setFilteredCount(filteredData.length)}}
        paginatorLeft={<></>}
        paginatorRight={<>Total: {filteredCount} / {purchases?purchases.length:0}</>}
      >
        <Column field="user_name" header="會員" sortable filter filterElement={filterInputText} headerStyle={{ width: 300 }}></Column>
        <Column field="user_group" header="組別" sortable filter filterElement={filterInputText} headerStyle={{ width: 200 }}></Column>
        <Column field="product_name" header="購買項目" sortable filter filterElement={filterInputText} headerStyle={{ width: 300 }}></Column>
        <Column field="price" header="金額" sortable filter filterElement={filterInputText} headerStyle={{ width: 200 }}></Column>
        <Column field="qty" header="點數" sortable filter filterElement={filterInputText} headerStyle={{ width: 200 }}></Column>
        <Column field="created_at" header="建立日期" body={(row) => formatListFields('created_at', row)} headerStyle={{ width: 200 }} sortable></Column>
      </DataTable>
      <Sidebar visible={isOpenDetail} position="right" onHide={() => {onHideSidebar()}} style={{ width: 500 }}>
        <div className="mt-1">
          {isLoadingDetail || purchaseDetail === null ?
            <div className="grid">
              <div className="col-12">
                <Skeleton className="mb-4 w-3 h-2rem"></Skeleton>
              </div>
              <div className="col-12">
                <Skeleton className="mb-2 w-2"></Skeleton>
                <Skeleton className="mb-2" height={160}></Skeleton>
              </div>
              <div className="col-12 flex justify-content-end gap-2">
                <Skeleton className="mb-2 w-2 h-2rem"></Skeleton>
              </div>
              <Divider />
              <div className="col-12 flex justify-content-end gap-2">
                <Skeleton className="mb-2 w-2 h-3rem"></Skeleton>
                <Skeleton className="mb-2 w-2 h-3rem"></Skeleton>
              </div>
            </div>
          :
            <>
              <div className="grid">
                <div className="col-12 flex align-items-center mb-4">
                  <h2 className="m-0">銷售點數內容</h2>
                </div>
                <div className="col-8">
                  <div className="text-base text-400 mb-1"><i className="pi pi-user mr-2"></i>會員名稱</div>
                  <div className="text-xl flex flex-row align-items-center">{purchaseDetail.users.nickname} <Tag value={purchaseDetail.users.employer_profiles.length > 0 ? '僱主' : purchaseDetail.users.helper_profiles.length > 0 ? '外傭' : '' } className="text-md ml-2"></Tag></div>
                </div>
                <div className="col-4 flex justify-content-end align-items-center">
                  {purchaseDetail.users.employer_profiles.length > 0 && <Button text label="" icon="pi pi-external-link" size="small" onClick={() => {window.open(`/employer/${purchaseDetail.users.id}`, '_blank')}} />}
                  {purchaseDetail.users.helper_profiles.length > 0 && <Button text label="" icon="pi pi-external-link" size="small" onClick={() => {window.open(`/helper/${purchaseDetail.users.id}`, '_blank')}} />}
                </div>
                <Divider align="left">銷售資訊</Divider>
                <div className="col-12">
                  <div className="text-base text-400 mb-1"><i className="pi pi-shopping-cart mr-2"></i>銷售方案</div>
                  <div className="text-xl">{purchaseDetail.product_name}</div>
                </div>
                <div className="col-12">
                  <div className="text-base text-400 mb-1"><i className="pi pi-sparkles mr-2"></i>點數</div>
                  <div className="text-xl">{purchaseDetail.qty} 點</div>
                </div>
                <Divider align="left">付款資訊</Divider>
                <div className="col-12">
                  <Tag value={purchaseDetail.sales_transactions.platform.toUpperCase()} className="text-md mr-1"></Tag>
                </div>
                <div className="col-12">
                  <div className="grid">
                    <div className="col-7">
                      <div className="text-base text-400 mb-1"><i className="pi pi-dollar mr-2"></i>付款金額</div>
                      <div className="flex flex-row align-items-center">
                        <div className="text-xl font-bold">{purchaseDetail.sales_transactions.currency} {purchaseDetail.sales_transactions.price_in_purchased_currency.toLocaleString()}</div>
                        <div className="text-md ml-4">(USD ${purchaseDetail.sales_transactions.price.toLocaleString()})</div>
                      </div>
                    </div>
                    <div className="col-5">
                      <div className="text-base text-400 mb-1">付款日期</div>
                      <div className="text-xl">{moment(purchaseDetail.sales_transactions.created_at).format('YYYY-MM-DD HH:mm')}</div>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="text-sm"><i className="pi pi-info-circle mr-2"></i> Platform Transaction ID: {purchaseDetail.sales_transactions.platform_id}</div>
                </div>
              </div>
              <div className="col-12 flex flex-column gap-2">
                <div className="flex align-items-center justify-content-end">
                </div>
              </div>
              <Divider />
              <div className="flex justify-content-end gap-2">
                <div className="flex gap-2">
                  <Button label="關閉" size="small" onClick={() => {onHideSidebar()}} outlined disabled={isSaving} />
                </div>
              </div>
            </>
          }
        </div>
      </Sidebar>
      <ConfirmDialog />
      <MessageBox visible={messageBoxData.show} title={messageBoxData.title} content={messageBoxData.content} type={messageBoxData.type} onHide={() => {setMessageBoxData({...messageBoxData,show:false})}} />
      <Toast ref={toast} position="top-center" />
    </>
  );
};
  
export default Purchase;
